import  { apiConfig } from "../helpers";
import { authHeader } from '../helpers';
import axios from 'axios';

export const settingsService = {
    GetCompanySettings,
    UpdateCompanySettings,
    GetCurrentCompanyFeatures,
    GetOrganizationalUnits,
    UpdateOrganizationalUnit,
    AddOrganizationalUnit,
    getAgreeTemplates,
    uploadAgreeTemplate,
    getAgreeTemplate,
    getAdditionalOutpotsts,
    insertAdditionalOutpost,
    updateAdditionalOutpost,
    getAdditionalOutpostsForDropdown,
    getNewAndroidQrCodeData,
    registerAndroidSmsDevice,
    uploadP1Certificates,
    getP1CertificatesStatus
};

function GetCompanySettings()
{
    return axios.get('/api/services/app/CompanySettings/GetCompanySettings', {        
        baseURL: apiConfig.apiUrl,
        headers: authHeader()        
    })
}

function getNewAndroidQrCodeData()
{
    return axios.get('/api/services/app/CompanySettings/GetNewAndroidQrCodeData', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader()
    })
}
function UpdateCompanySettings(data)
{

    return axios.put('/api/services/app/CompanySettings/UpdateCompanySettings',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),           
    })    
}
function GetCurrentCompanyFeatures()
{
    return axios.get('/api/services/app/Feature/GetAllFeatures', {        
        baseURL: apiConfig.apiUrl,
        headers: authHeader()        
    })
}
function GetOrganizationalUnits(companySettingsId)
{
    return axios.get('/api/services/app/CompanySettings/GetOrganizationalUnits', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            companySettingsId: companySettingsId
        }
    })
}
function UpdateOrganizationalUnit(data)
{

    return axios.put('/api/services/app/CompanySettings/UpdateOrganizationalUnit',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function AddOrganizationalUnit(data)
{
    return axios.post('/api/services/app/CompanySettings/AddOrganizationalUnit',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}

function getAgreeTemplates()
{
    return axios.get('/api/services/app/CompanySettings/GetAgreeTemplates', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader()
    })
}
function uploadAgreeTemplate(bodyData)
{
    let headers = authHeader()
    headers['Content-Type'] = 'multipart/form-data'
    return axios.post('/api/services/app/CompanySettings/UploadAgreeTemplate', bodyData, {
        baseURL: apiConfig.apiUrl,
        headers: headers
    })
}
function getAgreeTemplate(type)
{
    return axios.get('/api/services/app/CompanySettings/GetAgreeTemplate', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            type: type
        }
    })
}
function getAdditionalOutpotsts()
{
    return axios.get('/api/services/app/CompanySettings/GetAdditionalOutposts', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function insertAdditionalOutpost(data)
{
    return axios.post('/api/services/app/CompanySettings/InsertAdditionalOutpost',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function updateAdditionalOutpost(data)
{
    return axios.put('/api/services/app/CompanySettings/UpdateAdditionalOutpost',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function getAdditionalOutpostsForDropdown()
{
    return axios.get('/api/services/app/CompanySettings/GetAdditionalOutpostsForDropdown', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function registerAndroidSmsDevice(data)
{
    return axios.post('/api/services/app/CompanySettings/RegisterAndroidSmsDevice',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function uploadP1Certificates(bodyData)
{
    let headers = authHeader()
    headers['Content-Type'] = 'multipart/form-data'
    return axios.post('/api/services/app/CompanySettings/UploadP1Certificates', bodyData, {
        baseURL: apiConfig.apiUrl,
        headers: headers
    })
}
function getP1CertificatesStatus()
{
    return axios.get('/api/services/app/CompanySettings/GetP1CertificatesStatus', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader()
    })
}